import { UserQueueSettings } from '../../interfaces/user-queue-settings';
import { LimitOffsetPaging, Sort } from '../paged-results/limit-offset-paging.model';
import { ProviderDataReviewType } from 'app/core/enums/provider-data-review-type.enum';
import { ProviderDataReviewStatus } from 'app/core/enums/provider-data-review-status.enum';

export class ProviderDataReviewFilters {
  reviewType: ProviderDataReviewType[] = [];
  // NOTE: review status isn't available on the UI at this time,
  // we just default to showing open, but this allows us to show
  // closed ones in the future.
  reviewStatus: ProviderDataReviewStatus[] = [ProviderDataReviewStatus.open];

  assignedToIds: number[] = [];
  assignedClientLeadIds: number[] = [];
  excludeDirectUserAssignmentWorkflowClients = true;
}

export class ProviderDataReviewListSettings {
  filters: ProviderDataReviewFilters;
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
  sort: Sort;
}

export class MyProviderDataReviewQueueSettings {
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
}

export class ProviderDataReviewQueueSettings
  extends ProviderDataReviewListSettings implements UserQueueSettings {

  position: number;
}